import { FC } from 'react';
import { Field, Form } from 'react-final-form';
import { required } from '../../../helpers';
import { useUpdateLoanOffer } from '../../../hooks/loan/useUpdateLoanOffer';
import { LoanOffer } from '../../../interfaces';
import FormError from '../../Common/FormError';
import LoadingIndicator from '../../Common/LoadingIndicator';
import Modal from '../../Common/Modal';

type Props = {
  loanOffer: LoanOffer;
};

const EditLoanOffer: FC<Props> = ({ loanOffer }) => {
  const { onUpdateOfferHandler, updatingLoanOffer, showForm, toggleForm } = useUpdateLoanOffer(loanOffer.id);
  return (
    <>
      <button className='btn btn-light-primary btn-active-primary btn-sm me-3 fw-bold' onClick={toggleForm}>
        Edit
      </button>
      <Modal show={showForm} toggle={toggleForm} title='Update Your Loan Offer'>
        <Form
          initialValues={{
            tenure: loanOffer.tenure,
            interest: loanOffer.interest,
          }}
          onSubmit={onUpdateOfferHandler}
          render={({ handleSubmit }) => (
            <form onSubmit={handleSubmit}>
              <div className='mb-5'>
                <label className='form-label fs-7'>Tenure (Months)</label>
                <Field name='tenure' type='number' validate={(v) => required(v, 'Tenure')}>
                  {({ input, meta }) => (
                    <>
                      <input {...input} name='tenure' type='number' className='form-control form-control-lg form-control-solid' />
                      <FormError meta={meta} />
                    </>
                  )}
                </Field>
              </div>

              <div className='mb-5'>
                <label className='form-label fs-7'>Interest(%)</label>
                <Field name='interest' type='number' validate={(v) => required(v, 'Interest')}>
                  {({ input, meta }) => (
                    <>
                      <input {...input} name='interest' type='number' className='form-control form-control-lg form-control-solid' />
                      <FormError meta={meta} />
                    </>
                  )}
                </Field>
              </div>

              <div className='mt-10'>
                <button type='submit' disabled={updatingLoanOffer} className='btn btn-md btn-primary btn-sm me-3 ms-auto'>
                  {updatingLoanOffer ? <LoadingIndicator /> : 'Update Loan Offer'}
                </button>
              </div>
            </form>
          )}
        />
      </Modal>
    </>
  );
};

export default EditLoanOffer;
